<template>
  <div class="box">
    <div class="left-warp">
      <div class="left-table-box" ref="leftTebleBox">
        <nk-table
          :data="roleData"
          ref="multipleTable"
          :columns="columnsRole"
          :max-height="leftTableHeight - 20"
          :rowselect="true"
          @handleRowClick="handleLeftRowClick"
        ></nk-table>
      </div>
    </div>
    <div class="right-warp">
      <div class="btn-box">
        <el-button type="primary" @click="bindShowAdd">新增</el-button>
        <el-button type="primary" :disabled="isSureEdit" @click="bindShowEdit"
          >编辑</el-button
        >
        <el-button type="primary" @click="bindDel">删除</el-button>
      </div>
      <div class="table-box" ref="rightTableBox">
        <nk-table
          :data="tableData"
          :columns="columns"
          :rowselect="true"
          :max-height="rightTableHeight - 10"
          :arraySpanMethod="arraySpanMethod"
          @handleRowClick="handleRightRowClick"
        ></nk-table>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="showAddDialog"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form style="padding-top: 30px" :model="form" label-width="80px">
        <el-form-item label="页面:">
          <el-input
            disabled
            :value="form.pageName + '(' + form.pagePath + ')'"
          ></el-input>
        </el-form-item>
        <el-form-item label="参数名称:">
          <el-input :disabled="isEdit" v-model="form.param"></el-input>
        </el-form-item>
        <el-form-item label="值:">
          <el-input v-model="form.value" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button type="primary" class="btn" @click="bindAdd">确 定</el-button>
        <el-button @click="showAddDialog = false" class="cancel"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { creatMenuJson, getMountedOnName } from "@/utils/index.js";
import NkTable from "@/components/common/NkTable";
import { isNumber } from "util";
export default {
  components: { NkTable },
  data() {
    return {
      leftTableHeight: "",
      rightTableHeight: "",
      columnsRole: [
        { prop: "id", label: "id", show: false },
        { prop: "name", label: "角色名称", width: 120, show: true },
        { prop: "mountedOnName", label: "所在部门", show: true },
      ],
      orsData: [],
      roleData: [],
      tableData: [],
      columns: [
        { prop: "pageId", label: "pageId", show: false },
        { prop: "pageName", label: "页面名称", show: true },
        { prop: "pagePath", label: "页面地址", show: true },
        { prop: "param", label: "自定义页面参数", show: true },
        { prop: "value", label: "值", show: true },
      ],
      dialogTitle: "",
      currentRow: null,
      showAddDialog: false,
      form: {},
      isSureEdit: true,
      isEdit: true,
    };
  },
  mounted() {
    console.log();
    let vm = this;
    vm.leftTableHeight = vm.$refs.leftTebleBox.clientHeight;
    vm.rightTableHeight = vm.$refs.rightTableBox.clientHeight;
  },
  created() {
    let vm = this;
    vm.getLeftData();
  },
  methods: {
    getLeftData() {
      let vm = this;
      if (vm.orsData.length == 0) {
        vm.$api.orgStructNode
          .getORGStructNodes(this.$store.state.user.currentCompanyId)
          .then((res) => {
            vm.orsData = res.data;
            vm.$api.role
              .getRolesInfos(this.$store.state.user.currentCompanyId)
              .then((obj) => {
                vm.creatRoles(vm.orsData, obj.data);
              });
          });
      } else {
        vm.$api.role
          .getRolesInfos(this.$store.state.user.currentCompanyId)
          .then((res) => {
            vm.creatRoles(vm.orsData, res.data);
          });
      }
    },
    creatRoles(orsData, roles) {
      let vm = this;
      for (let index = 0; index < roles.length; index++) {
        const item = orsData.find((obj) => obj.id == roles[index].mountedOn);
        let name = "";
        if (item) {
          name = item.name + getMountedOnName(item.parentId, orsData);
          name = name.split("/").reverse().join("/");
        }
        roles[index].mountedOnName = name;
      }
      vm.roleData = roles;

      if (roles.length > 0) {
        vm.getTableData(roles[0].id);
        vm.$refs.multipleTable.setCurrentRow(vm.roleData[0], true);
      }
    },
    handleLeftRowClick(row) {
      let vm = this;
      vm.getTableData(row.id);
    },
    /**
     *  合并行
     */
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 2) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan,
        };
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
    },
    getTableData(roleId) {
      let vm = this;
      let tableData = [];
      vm.$api.role.getRolePrivilegeForPage(roleId).then((res) => {
        if (res) {
          let pageData = res.data;
          let apiArr = [];
          let eleArr = [];
          for (let index = 0; index < pageData.length; index++) {
            const element = pageData[index];
            eleArr.push({
              roleId: roleId,
              pageId: element.id,
              pageName: element.name,
              pagePath: element.path,
            });
            apiArr.push(
              vm.$api.customUrl.getFrontEndPageCustomParam(
                roleId,
                element.path,
                null
              )
            );
          }
          //获取所有页面的自定义页面参数
          Promise.all(apiArr).then((resArr) => {
            for (let i = 0; i < resArr.length; i++) {
              const obj = resArr[i];
              if (obj) {
                console.log(obj);
                if (obj.data.length > 0) {
                  console.log("65859898");
                  for (let j = 0; j < obj.data.length; j++) {
                    const paramData = obj.data[j];
                    let item = JSON.parse(JSON.stringify(eleArr[i]));
                    item.param = paramData.param;
                    item.value = paramData.value;
                    item.rowspan = j < 1 ? obj.data.length : 0;
                    item.colspan = j < 1 ? 1 : 0;
                    tableData.push(item);
                  }
                } else {
                  let item = eleArr[i];
                  item.rowspan = 1;
                  item.colspan = 1;
                  tableData.push(item);
                }
              }
            }
            vm.tableData = tableData;
          });
        }
      });
    },
    handleRightRowClick(row) {
      let vm = this;
      vm.isSureEdit = row.param ? false : true;
      vm.currentRow = row;
    },
    bindShowAdd() {
      let vm = this;
      if (!vm.currentRow) {
        vm.$message({
          message: "请选择你要新增参数的页面！",
          type: "warning",
        });
        return;
      }
      vm.isEdit = false;
      vm.form = {
        pageName: vm.currentRow.pageName,
        pagePath: vm.currentRow.pagePath,
        pageId: vm.currentRow.pageId,
        roleId: vm.currentRow.roleId,
        param: "",
        value: "",
      };
      vm.dialogTitle = "新增页面参数";
      vm.showAddDialog = true;
    },
    bindShowEdit() {
      let vm = this;
      if (!vm.currentRow) {
        vm.$message({
          message: "请选择你要修改参数！",
          type: "warning",
        });
        return;
      }
      vm.isEdit = true;
      vm.form = JSON.parse(JSON.stringify(vm.currentRow));
      vm.dialogTitle = "修改页面参数";
      vm.showAddDialog = true;
    },
    bindAdd() {
      let vm = this;
      if (vm.form.param.length == 0) {
        vm.$message({
          message: "请填写你的参数名称！",
          type: "warning",
        });
        return;
      }
      if (!vm.isEdit) {
        let item = vm.tableData.find(
          (obj) =>
            obj.pageId == vm.form.pageId &&
            obj.roleId == vm.form.roleId &&
            obj.param == vm.form.param
        );
        if (item) {
          vm.$message({
            message: "该角色在该页面存在相同的参数！",
            type: "warning",
          });
          return;
        }
      }
      vm.$api.customUrl
        .setFrontEndPageCustomParam(
          vm.form.roleId,
          vm.form.pagePath,
          vm.form.param,
          vm.form.value
        )
        .then((res) => {
          vm.$message("保存成功!");
          vm.showAddDialog = false;
          vm.getTableData(vm.form.roleId);
        });
    },
    bindDel() {
      let vm = this;
      console.log(
        "🚀 ~ file: roleParam.vue ~ line 305 ~ bindDel ~ vm.currentRow",
        vm.currentRow
      );
      if (!vm.currentRow) {
        vm.$message({
          message: "请选择你要删除的参数！",
          type: "warning",
        });
        return;
      }
      this.$confirm("是否删除您选中的参数?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        vm.$api.customUrl
          .deleteFrontEndPageCustomParam(
            vm.currentRow.roleId,
            vm.currentRow.pagePath,
            vm.currentRow.param
          )
          .then((res) => {
            if (res) {
              vm.$message("删除成功!");
              vm.getTableData(vm.currentRow.roleId);
            }
          })
          .catch((error) => {
            this.$message.error(error.data.msg);
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tree-title {
  background: #003681;
  height: 40px;
  line-height: 40px;
  padding-left: 8px;
  color: #fff;
  box-sizing: border-box;
  font-size: 16px;
  margin-bottom: 2px;
}
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row;
}
.left-warp {
  flex: 0 0 350px;
  background: #fff;
}
.right-warp {
  margin-left: 10px;
  flex: 1;
}
.left-table-box {
  padding: 10px;
  height: 100%;
  box-sizing: border-box;
}
.el-row {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.top {
  padding-bottom: 20px;
  min-height: 300px;
}
.el-col {
  border-radius: 4px;
  height: 100%;
}
.grid-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #99a9bf;
}
.parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.tree_parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.treecontent {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
  border: 1px solid #eee;
  box-sizing: border-box;
}

.right-warp {
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  height: 100%;
}
.btn-box {
  text-align: right;
}
.table-box {
  padding-top: 10px;
  height: calc(100% - 50px);
}
</style>
